module.exports = __webpack_public_path__ + "static/media/icon-1w.54b7cd61.svg";